<template>
    <div class="header-guide" :class="{'is-fixed': isFixed, 'modern-guide': modern}">
        <div class="container">
            <div class="guide-left">
                <h1 class="logo">
                    <a href="/">
                        <span class="modern-brand-mark">询</span><span class="modern-brand-copy"><strong>询龙网</strong><em>PROJECT PRO CROWDSOURCING</em></span>
                    </a>
                </h1>

                <ul class="guide-nav">
                    <li>
                        <a href="javascript:;">
                            <router-link class="nav-link" to="/">首页</router-link>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:;">
                            <router-link class="nav-link" to="/geek/list">找工程极客</router-link>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:;">
                            <router-link class="nav-link" to="/task/list">找外包项目</router-link>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:;">
                            <router-link class="nav-link" :class="{ 'is-active': isResourceRoute }" to="/article/index">资源中心</router-link>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:;">
                            <router-link class="nav-link" to="/protocol/index/3">交易保障</router-link>
                        </a>
                    </li>
                </ul>
            </div>

            <div class="guide-right searchBox">
                <el-button
                    v-if="userInfo.isLogin==false || userInfo.info.user_type == 2"
                    class="publish-btn modern-publish-btn"
                    @click="addtask"
                >免费发布项目</el-button>

                <router-link class="modern-flow-link" to="/flow/index">合作交流</router-link>
                <router-link class="modern-attest-btn" to="/user/attest">工程师入驻</router-link>
                <div class="sel-type-wrap modern-search-type">
                    <el-select
                        v-model="searchTypeValue"
                        @change="changeSearchTypeEvent"
                        class="search-type search_type"
                    >
                        <el-option value="项目" label="项目"></el-option>
                        <el-option value="极客" label="极客"></el-option>
                    </el-select>
                </div>

                <div class="hd-form">
                    <input
                        class="seach-ipt"
                        type="text"
                        v-model="keywords"
                        placeholder="请输入搜索关键字"
                        @keyup.enter.down="search"
                    />
                    <el-button @click="search">搜索</el-button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    name: "HeaderGuide",
    computed: {
        ...mapState(["userInfo"]),
        ...mapState(["websitInfo"]),
        isResourceRoute() { return this.$route.path === "/article/index" || this.$route.path.indexOf("/article/detail/") === 0; }
    },
    props: { keyword: String, modern: { type: Boolean, default: false } },
    data() {
        return {
            keywords: "",
            searchTypeValue: "项目",
            isFixed: false // 是否滚动固定搜索栏
        };
    },
    created() {
        var _this = this;

        //赋值父组件传进来的关键字
        setTimeout(() => {
            this.keywords = this.keyword ? this.keyword : "";
        }, 100);

        //默认设置搜索类型
        let searchtypeValue = sessionStorage.getItem("searchTypeValue");
        if (searchtypeValue) {
            this.searchTypeValue = searchtypeValue;
        } else {
            sessionStorage.setItem("searchTypeValue", this.searchTypeValue);
        }

        /* 滚动跟随搜索栏  */
        window.onscroll = function () {
            //为了保证兼容性，这里取两个值，哪个有值取哪一个
            //scrollTop就是触发滚轮事件时滚轮的高度
            var scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 40) {
                _this.isFixed = true;
            } else {
                _this.isFixed = false;
            }
            _this.$emit("winscroll", scrollTop);
        };
    },
    mounted() { if (this.modern) document.documentElement.classList.add("xl-modern-detail"); },
    beforeDestroy() { if (this.modern) document.documentElement.classList.remove("xl-modern-detail"); },
    methods: {
        ...mapActions("userInfo", ["loginOut"]),
        goDetail() {
            this.$router.push("/article/index");
        },
        regClick() {
            this.$router.push("/register/index/master");
        },
        loginClick() {
            this.$router.push("/login/index?type=login");
        },
        go_to(name) {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.$router.push({ name: name });
        },

        go_Logingout(n = 0) {
            this.loginOut(); //退出登录
            if (n == 0) {
                this.$router.push("/");
            } else {
                this.$router.push("/login/index");
            }
        },

        //改变搜索类型事件
        changeSearchTypeEvent(e) {
            sessionStorage.setItem("searchTypeValue", e);
        },

        //搜索
        search() {
            let searchTypeValue = sessionStorage.getItem("searchTypeValue");
            if (searchTypeValue == "项目") {
                this.$router.push("/task/list?keyword=" + this.keywords);
            } else {
                this.$router.push("/geek/list?keyword=" + this.keywords);
            }
        },

        //跳转到发布项目页面
        addtask() {
            //用户已登录
            if (this.userInfo.isLogin == true) {
                //雇主
                if (this.userInfo.info.user_type == 2) {
                    //是否需要认证才能发布项目（1.需要认证；0.不需要认证）
                    if (this.userInfo.config.is_atte == 1) {
                        if (
                            this.userInfo.attestation != "" &&
                            this.userInfo.info.attestation == 2
                        ) {
                            //已经认证
                            this.$router.push("/task/publish"); //跳转到发布项目
                        } else {
                            this.$message.error(
                                "请先完成雇主认证，才能发布项目"
                            );
                            setTimeout(() => {
                                this.$router.push("/user/attest");
                            }, 1000);
                        }
                    } else {
                        this.$router.push("/task/publish"); //跳转到发布项目
                    }
                } else {
                    this.$message.error("只有雇主才能发布项目，请注册成为雇主");
                }
            } else {
                this.$message.error("请先登录后再操作");
                this.$router.push("/login/index?type=login");
            }
        }
    }
};
</script>

<style lang="less">
@import (reference) "../../styles/palette.less";
.modern-guide {
    height: 80px; background: #fff; border-bottom: 1px solid #e2e8f0; box-shadow: none;
    .container { max-width: 1280px; width: 100%; height: 100%; padding: 0 32px; display: flex; align-items: center; justify-content: space-between; }
    .guide-left { float: none; display: flex; align-items: center; min-width: 0; }
    .logo { float: none; width: 174px; height: auto; margin: 0 22px 0 0; display: flex; align-items: center; }
    .logo a { display: flex; align-items: center; width: 100%; height: auto; background: none !important; }
    .modern-brand-mark { width: 44px; height: 44px; display: grid; place-items: center; flex: 0 0 auto; border-radius: 12px; background: @palette-gradient; color: #fff; font-size: 28px; font-weight: 900; box-shadow: 0 2px 5px fade(@palette-action, 19%); }
    .modern-brand-copy { display: block; margin-left: 10px; line-height: 1.1; strong { display: block; color: #0f172a; font-size: 23px; font-weight: 900; white-space: nowrap; } em { display: block; margin-top: 4px; color: #8190a6; font-size: 8px; letter-spacing: .4px; font-style: normal; white-space: nowrap; } }
    .guide-nav { float: none; height: auto; display: flex; align-items: center; gap: 4px; margin: 0; li { margin: 0; height: auto; a { display: block; height: auto; padding: 9px 11px; color: #0f172a; font-size: 13px; line-height: 1.5; } a:hover { color: @palette-text; } } }
    .guide-nav li a.is-active { color: @palette-text; background: @palette-tint; border-radius: 9px; }
    .guide-right { float: none; display: flex; align-items: center; gap: 10px; margin: 0; }
    .modern-flow-link { color: #0f172a; font-size: 13px; font-weight: 700; white-space: nowrap; &:hover { color: @palette-text; } }
    .modern-attest-btn { padding: 10px 14px; border: 1px solid @palette-action; border-radius: 10px; color: @palette-text; background: #fff; font-size: 12px; font-weight: 700; white-space: nowrap; }
    .modern-publish-btn { order: 3; min-height: 40px; padding: 10px 15px; border: 0; border-radius: 11px; background: @palette-gradient; color: white; font-size: 12px; font-weight: 700; white-space: nowrap; }
    .modern-search-type { order: 1; width: 76px; .el-input__inner { border: 1px solid #e2e8f0; border-radius: 9px 0 0 9px; color: #334155; font-size: 12px; } }
    .hd-form { order: 2; display: flex; height: 40px; width: 210px; border: 1px solid #e2e8f0; border-radius: 0 9px 9px 0; overflow: hidden; .seach-ipt { min-width: 0; flex: 1; border: 0; padding: 0 10px; color: #334155; font-size: 12px; outline: none; } .el-button { height: 100%; padding: 0 14px; border: 0; border-radius: 0; background: @palette-gradient; color: #fff; font-size: 12px; &:hover { background: @palette-hover; } } }
    &.is-fixed { top: 37px; box-shadow: 0 3px 12px #0f172a12; }
    @media (max-width: 1200px) { .container { padding: 0 16px; } .logo { width: 150px; margin-right: 8px; } .modern-brand-copy strong { font-size: 20px; } .guide-nav { gap: 0; } .guide-nav li a { padding: 8px 6px; font-size: 12px; } .modern-flow-link { display: none; } .hd-form { width: 150px; } .modern-attest-btn { display: none; } }
    @media (max-width: 650px) { height: auto; min-height: 72px; .container { flex-wrap: wrap; padding: 10px 16px; gap: 8px; } .guide-left { width: 100%; } .guide-nav { margin-left: auto; } .guide-nav li:nth-child(5) { display: none; } .guide-right { width: 100%; } .hd-form { flex: 1; width: auto; } .modern-publish-btn { font-size: 11px; padding: 9px 10px; } }
}
html.xl-modern-detail, html.xl-modern-detail body { min-width: 0; }
.search_type {
    .el-input__inner {
        height: 90% !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/HeaderGuide.vue